/* unplugin-vue-components disabled */import script from "./MainComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./MainComponents.vue?vue&type=script&setup=true&lang=js"

import "./MainComponents.vue?vue&type=style&index=0&id=c3faf494&lang=less"

const __exports__ = script;

export default __exports__